import { DeleteOutlined, EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Col, Row, Space, Upload } from "antd";
import { useRef } from "react";
import "./UploadMultiple.scss";
import { nofication } from './../Nofication';
import { useState } from "react";
import { useEffect } from "react";

const MenuLeft = ({
    imageUrl,
    setFileList,
    setImageUrl,
    setIdsRemove,
    idsRemove,
    imgCurrent,
    fileList,
    span = 8,
    setIsCheckRemoveImg = undefined,
}) => {
    const ref = useRef();
    const beforeUpload = (file) => {
        return false;
    };

    const handleChange = async (info) => {
        const files = info.target.files;
        setFileList([...fileList, ...info.target.files]);
        setImageUrl([]);
        const arImg = [];
        for (let i = 0; i < files.length; i++) {
            const size = files[i].size / 1024;
            arImg.unshift(URL.createObjectURL(files[i]));
        }
        setImageUrl([...arImg, ...imageUrl]);
    };

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            if (setIsCheckRemoveImg) {
                setIsCheckRemoveImg(false);
            }
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const openModal = () => {
        setPreviewImage(true);
    };

    const onRemoveImage = () => {
        setImageUrl("");
        setFileList("");
        if (setIsCheckRemoveImg) {
            setIsCheckRemoveImg(true);
        }
    };

    const removeImg = (id, index, index2) => {
        console.log('index', index);
        if (index === 'id') {
            const imagesNew = imageUrl.filter(item => item.id !== id);
            setImageUrl([...imagesNew]);
            setIdsRemove([...idsRemove, id]);
        } else {
            const imagesNew = imageUrl.filter((item, index) => index !== id);
            const list = fileList.filter((item, index) => index !== id);
            setImageUrl([...imagesNew]);
            setFileList([...list]);
            console.log('list', list);
        }
        // nofication('warning','Cảnh báo', 'Chức năng đang update!');
    };

    return (
        <>
            <Col span={24}>
                <div className="wrapper-img-banner">
                    {imageUrl.map((item, index) => {
                        return (
                            <div className="wrap-img" key={`http://localhost:8000/${index}`}>
                                <div className="close-img" onClick={() => removeImg(item.id ? item.id : index, item.id ? 'id' : 'index', index)}>
                                    <img src="/icon/close_img.svg" alt="" />
                                </div>
                                {
                                    Object.keys(item).length > 0
                                        ? <img src={`${item.name ? '/' + item.name : item}`} alt="2" />
                                        : <></>
                                }
                            </div>
                        );
                    })}
                </div>
            </Col>
            {/* <Row> */}
            {/* <Upload
                    ref={ref}
                    name="image"
                    className="upload"
                    onChange={handleChange}
                    multiple={true}
                    beforeUpload={beforeUpload}
                    showUploadList={false}
                    accept="image/*"
                >
                    <Button
                        type="primary"
                        className="btn-upload"
                        icon={<UploadOutlined className="icon-upload" />}
                    >
                        Upload
                    </Button>
                </Upload> */}
            {/* <label htmlFor="filePicker" style={{ background: "grey", padding: "5px 10px" }}>
                    My custom choose file label
                </label>
                <input id="filePicker"  type="file"}> */}
            <input type="file" name="files[]" multiple onChange={handleChange} style={{ visibility: "hidden" }} id="filePicker" accept="image/png, image/gif, image/jpeg" />
            {/* <input type="file" name="file" id="file" class="inputfile"> */}
            <label for="file" htmlFor="filePicker" style={{ background: "#1890ff", padding: "5px 10px", color: "white", borderRadius: 5, width: 100, textAlign: 'center', cursor: 'pointer' }}><UploadOutlined className="icon-upload" style={{ marginRight: 10 }} />Upload</label>
            {/* </Row> */}
        </>
    );
};
export default MenuLeft;
